import { gql } from '@apollo/client';
export const CRM_OBJECT_FRAGMENT = {
  kind: "Document",
  definitions: [{
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "CrmObjectFragment"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "CrmObject"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "id"
        }
      }, {
        kind: "Field",
        alias: {
          kind: "Name",
          value: "objectId"
        },
        name: {
          kind: "Name",
          value: "id"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "allProperties"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "id"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "name"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "value"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "source"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "userPermissions"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "currentUserCanView"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "currentUserCanEdit"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "currentUserCanDelete"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "currentUserCanCommunicate"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "associationsBySpec"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "associationSpecs"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "associationSpecs"
            }
          }
        }],
        directives: [{
          kind: "Directive",
          name: {
            kind: "Name",
            value: "include"
          },
          arguments: [{
            kind: "Argument",
            name: {
              kind: "Name",
              value: "if"
            },
            value: {
              kind: "Variable",
              name: {
                kind: "Name",
                value: "hasAssociationSpecs"
              }
            }
          }]
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "associatedObjects"
            },
            arguments: [{
              kind: "Argument",
              name: {
                kind: "Name",
                value: "first"
              },
              value: {
                kind: "IntValue",
                value: "1"
              }
            }],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "edges"
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "node"
                    },
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [{
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "id"
                        }
                      }, {
                        kind: "Field",
                        alias: {
                          kind: "Name",
                          value: "objectId"
                        },
                        name: {
                          kind: "Name",
                          value: "id"
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "allProperties"
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "id"
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "name"
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "value"
                            }
                          }]
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "userPermissions"
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "currentUserCanView"
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "currentUserCanEdit"
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "currentUserCanDelete"
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "currentUserCanCommunicate"
                            }
                          }]
                        }
                      }]
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "associationDefinition"
                    },
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [{
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "associationTypeId"
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "name"
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "associationCategory"
                        }
                      }]
                    }
                  }]
                }
              }]
            }
          }]
        }
      }]
    }
  }]
};